import { FeedbackStep } from 'src/modules/programs/feedback/stepComponents/FeedbackStep';
import { ProgramSharedStep, ProgramWeekEnum } from 'src/modules/programs/models/programs';
import flexibilityIcon from 'src/public/img/flexibility.png';

import { CPProgramStepProps } from '../../models/cpProgram';
import { CPProgramSharedStep } from '../../weekShared/models/weekShared';
import { CPProgramWeekFourStep } from '../models/weekFour';
import { CheckInAboutPracticeStep } from '../stepComponents/CheckInAboutPracticeStep';
import { DevelopingFlexibilityStep } from '../stepComponents/DevelopingFlexibilityStep';
import { DoItAnywayStep } from '../stepComponents/DoItAnywayStep';
import { EndOfCourseStep } from '../stepComponents/EndOfCourseStep';
import { FlexibilityExerciseStep } from '../stepComponents/FlexibilityExerciseStep';
import { FlexibilityPracticeStep } from '../stepComponents/FlexibilityPracticeStep';
import { GratitudeStep } from '../stepComponents/GratitudeStep';
import { SeeYourThoughtsStep } from '../stepComponents/SeeYourThoughtsStep';
import { WeekFourPlanStep } from '../stepComponents/WeekFourPlanStep';
import { WhatIsFlexibilityStep } from '../stepComponents/WhatIsFlexibilityStep';

const steps: (ProgramSharedStep | CPProgramSharedStep | CPProgramWeekFourStep)[] = [
    ProgramSharedStep.WellbeingCheckInStep,
    ProgramSharedStep.WellbeingScoreStep,
    ProgramSharedStep.FeedbackStep,
    CPProgramWeekFourStep.ChekInAboutPracticeStep,
    CPProgramWeekFourStep.WhatIsFlexibilityStep,
    CPProgramWeekFourStep.DevelopingFlexibilityStep,
    CPProgramWeekFourStep.SeeYourThoughtsStep,
    CPProgramWeekFourStep.FlexibilityExerciseStep,
    CPProgramWeekFourStep.FlexibilityPracticeStep,
    CPProgramWeekFourStep.DoItAnywayStep,
    ProgramSharedStep.PlanStep,
    CPProgramWeekFourStep.GratitudeStep,
    ProgramSharedStep.EndOfCourseStep,
    CPProgramSharedStep.CorePillarsCheckInStep,
    ProgramSharedStep.ProgramFeedbackStep,
];

const stepsProps: CPProgramStepProps[] = [
    {
        id: CPProgramWeekFourStep.WhatIsFlexibilityStep,
        component: WhatIsFlexibilityStep,
        tooltip: 'What is Psychological Flexibility?',
        flexGrow: false,
    },
    {
        id: CPProgramWeekFourStep.DevelopingFlexibilityStep,
        component: DevelopingFlexibilityStep,
        tooltip: 'Developing Flexibility',
    },
    {
        id: CPProgramWeekFourStep.SeeYourThoughtsStep,
        component: SeeYourThoughtsStep,
        tooltip: 'See Your Thoughts',
        flexGrow: false,
    },
    {
        id: CPProgramWeekFourStep.FlexibilityExerciseStep,
        component: FlexibilityExerciseStep,
        tooltip: 'Flexibility Exercise',
        noButtons: true,
        grayBackground: true,
    },
    {
        id: CPProgramWeekFourStep.FlexibilityPracticeStep,
        component: FlexibilityPracticeStep,
        tooltip: 'Flexibility Practice',
        noButtons: true,
        grayBackground: true,
    },
    {
        id: CPProgramWeekFourStep.DoItAnywayStep,
        component: DoItAnywayStep,
        tooltip: 'Do it Anyway!',
        flexGrow: false,
    },
    {
        id: ProgramSharedStep.PlanStep,
        component: WeekFourPlanStep,
        tooltip: 'Over the next week...',
        noButtons: true,
    },
    {
        id: CPProgramWeekFourStep.GratitudeStep,
        component: GratitudeStep,
        tooltip: 'Practice Gratitude',
        noButtons: true,
        grayBackground: true,
    },
    {
        id: CPProgramWeekFourStep.ChekInAboutPracticeStep,
        component: CheckInAboutPracticeStep,
        tooltip: 'What actions did you do last week?',
        noButtons: true,
        grayBackground: true,
    },
    {
        id: ProgramSharedStep.EndOfCourseStep,
        component: EndOfCourseStep,
        tooltip: 'End of the Course',
        flexGrow: false,
    },
    {
        id: ProgramSharedStep.ProgramFeedbackStep,
        component: FeedbackStep,
        tooltip: 'Program Feedback',
        noButtons: true,
        grayBackground: true,
    },
];

const t = (key: string) => `cp:week-4.data.${key}`;

export const weekFourData = {
    id: ProgramWeekEnum.WeekFour,
    title: t('title'),
    definition: t('definition'),
    description: t('description'),
    endOfCourseDefinition: t('endOfCourseDefinition'),
    feedbackPlaceholder: t('feedbackPlaceholder'),
    iconUrl: flexibilityIcon,
    weekNumber: 3,
    readableWeekNumber: 4,
    greetingModalContent: t('greetingModalContent'),
    steps,
    stepsProps,
};

export const flexibilityExerciseAnswers = ['Unmotivated', `I don't want to`, 'Other'];

export const initialFlexibilityExerciseData = [
    {
        id: 0,
        text: '',
        answers: [],
    },
];

export const flexibilityPlanFeelings = [
    'Scared',
    'Anxious',
    'Fearful',
    'Nervous',
    'Excited',
    'Other',
];

export const initialFlexibilityPlan = [
    {
        id: 0,
        text: '',
        answers: [],
    },
];

export const initialFlexibilityPracticeData = {
    id: 0,
    text: '',
    answer: '',
};

export const checkInActionsAnswer = ['Accomplished', 'Anxious', 'Fulifilled', 'Happy'];

export const initialProgramFeedback = {
    rating: 0,
    content: '',
    recommendationProbability: 0,
};
